export default {
  title: 'Quick Actions',
  send_push_notification: {
    label: 'Send Push Notification',
    description: 'Create a new campaign',
  },
  email_campaign: {
    label: 'Email Campaign',
    description: 'Send to subscribers',
  },
  view_analytics: {
    label: 'View Analytics',
    description: 'Campaign performance',
  },
};
